export { default } from './TemplateCard';
export * from './TemplateCard';
